import { render, staticRenderFns } from "./FieldModsWidget.vue?vue&type=template&id=56dc1586&scoped=true"
import script from "./FieldModsWidget.vue?vue&type=script&lang=js"
export * from "./FieldModsWidget.vue?vue&type=script&lang=js"
import style0 from "./FieldModsWidget.vue?vue&type=style&index=0&id=56dc1586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc1586",
  null
  
)

export default component.exports